import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import icon1 from '../assets/images/resources/dev_2.png';
import icon2 from '../assets/images/resources/dev_36.png';
import icon3 from '../assets/images/resources/dev_39.png';
import icon4 from '../assets/images/resources/dev_66.png';

const Features = () => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        features_heading
        features {
          id
          feature_heading
          feature_description
        }
      }
    }
  `);

  const {
    strapiHomePage: { features_heading, features },
  } = data;

  return (
    <section className='service-one' id='features'>
      <div className='container'>
        <div className='block-title text-center'>
          <h2 className='block-title__title'>{features_heading}</h2>
        </div>
        <div className='row'>
          <div
            className='col-lg-3 col-md-6 col-sm-12 wow fadeInUp'
            data-wow-duration='1500ms'
          >
            <div className='service-one__single text-center'>
              <div className='service-one__inner'>
                {/* <i className='service-one__icon dimon-icon-laptop'></i> */}
                <img src={icon2} alt='' className='feature-icon first-icon' />
                <h3>{features[0].feature_heading}</h3>
                <p>{features[0].feature_description}</p>
              </div>
            </div>
          </div>
          <div
            className='col-lg-3 col-md-6 col-sm-12 wow fadeInDown'
            data-wow-duration='1500ms'
          >
            <div className='service-one__single text-center'>
              <div className='service-one__inner'>
                {/* <i className='service-one__icon dimon-icon-presentation'></i> */}
                <img src={icon3} alt='' className='feature-icon second-icon' />
                <h3>{features[1].feature_heading}</h3>
                <p>{features[1].feature_description}</p>
              </div>
            </div>
          </div>
          <div
            className='col-lg-3 col-md-6 col-sm-12 wow fadeInUp'
            data-wow-duration='1500ms'
          >
            <div className='service-one__single text-center'>
              <div className='service-one__inner'>
                {/* <i className='service-one__icon dimon-icon-target'></i> */}
                <img src={icon1} alt='' className='feature-icon third-icon' />

                <h3>{features[2].feature_heading}</h3>
                <p>{features[2].feature_description}</p>
              </div>
            </div>
          </div>
          <div
            className='col-lg-3 col-md-6 col-sm-12 wow fadeInDown'
            data-wow-duration='1500ms'
          >
            <div className='service-one__single text-center'>
              <div className='service-one__inner'>
                {/* <i className='service-one__icon dimon-icon-visualization'></i> */}
                <img src={icon4} alt='' className='feature-icon fourth-icon' />

                <h3>{features[3].feature_heading}</h3>
                <p>{features[3].feature_description}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Features;
